import { render, staticRenderFns } from "./partner_administrators_dialog.vue?vue&type=template&id=ab121fb2"
import script from "./partner_administrators_dialog.vue?vue&type=script&lang=js"
export * from "./partner_administrators_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports